import { styled } from "styled-components";

import { colorCSS, radius } from "../../styles";

export const Dropdown = styled.div({
    textAlign: "left"
});

export const DropdownButton = styled.button({
    "backgroundColor": colorCSS("N0"),
    "borderRadius": radius.button,
    "border": `1px solid ${colorCSS("N0")}`,
    "color": colorCSS("N900"),
    "cursor": "pointer",
    "padding": "0.5rem 1rem",
    "textAlign": "left",
    "textDecoration": "none",

    "&:hover": {
        backgroundColor: colorCSS("N20"),
        borderColor: colorCSS("N20")
    },

    "&:active": {
        backgroundColor: colorCSS("N40"),
        borderColor: colorCSS("N40")
    }
});

export const BottomArrow = styled.span({
    backgroundImage: `linear-gradient( 45deg, transparent 50%, ${colorCSS(
        "N900"
    )} 50% ), linear-gradient(135deg, ${colorCSS(
        "N900"
    )} 50%, transparent 50%)`,
    backgroundPosition:
        "calc(100% - 5px) calc(0.5em + 5px), calc(100%) calc(0.5em + 5px)",
    backgroundSize: "5px 5px, 5px 5px",
    backgroundRepeat: "no-repeat",
    paddingRight: "1.5rem"
});

export const DropdownWorkspace = styled.div({
    marginTop: "0.1rem",
    display: "block",
    position: "absolute",
    height: "100%",
    width: "90%",
    zIndex: 200,
    whiteSpace: "normal",

    a: {
        "display": "block",
        "border": `1px solid ${colorCSS("N20")}`,
        "color": colorCSS("N900"),
        "backgroundColor": colorCSS("N0"),
        "padding": "0.5rem 1rem",
        "textDecoration": "none",
        "position": "relative",
        "maxWidth": "90%",

        "&:hover": {
            backgroundColor: colorCSS("N10")
        }
    },

    span: {
        display: "block",
        border: `1px solid ${colorCSS("N20")}`,
        color: colorCSS("N900"),
        backgroundColor: colorCSS("N0"),
        padding: "0.5rem 1rem",
        textDecoration: "none",
        position: "relative",
        maxWidth: "90%"
    }
});
